export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Facility/Group\",\n    \"label_other\": \"{{count}} Facility/Group\"\n}\n"